import templateUrl from "emun.order/order-details-header.htm";
import controller from "emun.order/order-details-header.controller";

export default {
  bindings: {
        order: "<",
    showLocationIds: "<?",
    mode: "<",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
